import {
    IS_GET_LEAGUES_LOADING,
    LEAGUES_FETCH_DATA_SUCCESS,
    LEAGUES_HAS_ERROR,
    IS_GET_LEAGUE_MEMBERS_LOADING,
    LEAGUE_MEMBERS_FETCH_DATA_SUCCESS,
    LEAGUE_MEMBERS_HAS_ERROR,
    IS_CREATE_LEAGUE_LOADING,
    CREATE_LEAGUE_FETCH_DATA_SUCCESS,
    CREATE_LEAGUE_HAS_ERROR,
    IS_JOIN_LEAGUE_LOADING,
    JOIN_LEAGUE_FETCH_DATA_SUCCESS,
    JOIN_LEAGUE_HAS_ERROR,
    IS_LEAVE_LEAGUE_LOADING,
    LEAVE_LEAGUE_FETCH_DATA_SUCCESS,
    LEAVE_LEAGUE_HAS_ERROR,
    IS_RELAUNCH_LEAGUE_LOADING,
    RELAUNCH_LEAGUE_FETCH_DATA_SUCCESS,
    RELAUNCH_LEAGUE_HAS_ERROR,
    IS_RE_JOIN_LEAGUE_LOADING,
    RE_JOIN_LEAGUE_FETCH_DATA_SUCCESS,
    RE_JOIN_LEAGUE_HAS_ERROR,
    IS_DELETE_LEAGUE_LOADING,
    DELETE_LEAGUE_FETCH_DATA_SUCCESS,
    DELETE_LEAGUE_HAS_ERROR,
    IS_PREVIOUS_SEASON_DELETE_LEAGUE_LOADING,
    PREVIOUS_SEASON_DELETE_LEAGUE_FETCH_DATA_SUCCESS,
    PREVIOUS_SEASON_DELETE_LEAGUE_HAS_ERROR,
    IS_PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_LOADING,
    PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_FETCH_DATA_SUCCESS,
    PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_HAS_ERROR,
    IS_SUSPEND_LEAGUE_LOADING,
    SUSPEND_LEAGUE_FETCH_DATA_SUCCESS,
    SUSPEND_LEAGUE_HAS_ERROR,
    IS_REMOVE_SUSPENSION_LOADING,
    REMOVE_SUSPENSION_FETCH_DATA_SUCCESS,
    REMOVE_SUSPENSION_HAS_ERROR,
    IS_PUBLIC_LEAGUES_LOADING,
    PUBLIC_LEAGUES_FETCH_DATA_SUCCESS,
    PUBLIC_LEAGUES_HAS_ERROR,
    IS_LEAGUE_LEADERBOARD_LOADING,
    LEAGUE_LEADERBOARD_HAS_ERROR,
    LEAGUE_LEADERBOARD_FETCH_DATA_SUCCESS,
    IS_RENAME_LEAGUE_LOADING,
    RENAME_LEAGUE_HAS_ERROR,
    RENAME_LEAGUE_FETCH_DATA_SUCCESS,
    IS_LEAGUE_LEADERBOARD_PUBLIC_LOADING,
    LEAGUE_LEADERBOARD_PUBLIC_FETCH_DATA_SUCCESS,
    LEAGUE_LEADERBOARD_PUBLIC_HAS_ERROR,
    IS_LEAGUE_LEADERBOARD_RANK__LOADING,
    LEAGUE_LEADERBOARD_RANK__FETCH_DATA_SUCCESS,
    LEAGUE_LEADERBOARD_RANK__HAS_ERROR,
    IS_GET_OTHERS_TEAM_LOADING,
    GET_OTHERS_TEAM_SUCCESS,
    GET_OTHERS_TEAM_HAS_ERROR,
    UPDATE_FAV_TEAM_LOADING,
    UPDATE_FAV_TEAM_ERROR,
    UPDATE_FAV_TEAM_SUCCESS,
} from './../constants/action-types';
import {
    getLeagues,
    getPublicLeagues,
    getMembers,
    getLeagueLeaderBoard,
    postCreateLeague,
    postJoinLeague,
    postLeaveLeague,
    postRelaunchLeague,
    postReJoinLeague,
    postDeleteLeague,
    postPreviousSeasonDeleteLeague,
    postPreviousSeasonMemberDeleteLeague,
    postSuspendLeague,
    postRemoveSuspensionLeague,
    updateLeagueName,
    publicLeaderBoard,
    publicLeaderBoardRank,
    viewOtherUsersTeam,
    postFavTeam
} from "../constants/api-url";
import config from './../config';
import common from './../common';
let clubName = ""
export function isGetLeagueLoading(bool) {
    return {
        type: IS_GET_LEAGUES_LOADING,
        payload: bool
    };
}

export function leaguesFetchDataSuccess(data) {
    return {
        type: LEAGUES_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function leaguesHasError(bool) {
    return {
        type: LEAGUES_HAS_ERROR,
        payload: bool
    };
}

export function isUpdateLeagueNameLeagueLoading(bool) {
    return {
        type: IS_RENAME_LEAGUE_LOADING,
        payload: bool
    };
}

export function leagueNameUpdateFetchDataSuccess(data) {
    return {
        type: RENAME_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function updateLeaguesHasError(bool) {
    return {
        type: RENAME_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isGetOthersTeamLoading(bool) {
    return {
        type: IS_GET_OTHERS_TEAM_LOADING,
        payload: bool
    };
}

export function GetOthersTeamFetchDataSuccess(data) {
    return {
        type: GET_OTHERS_TEAM_SUCCESS,
        payload: data
    };
}

export function GetOthersTeamHasError(bool) {
    return {
        type: GET_OTHERS_TEAM_HAS_ERROR,
        payload: bool
    };
}

export function isPublicLeagueLoading(bool) {
    return {
        type: IS_PUBLIC_LEAGUES_LOADING,
        payload: bool
    };
}

export function publicLeaguesFetchDataSuccess(data) {
    return {
        type: PUBLIC_LEAGUES_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function publicLeaguesHasError(bool) {
    return {
        type: PUBLIC_LEAGUES_HAS_ERROR,
        payload: bool
    };
}

export function isLeagueLeaderBoardLoading(bool) {
    return {
        type: IS_LEAGUE_LEADERBOARD_LOADING,
        payload: bool
    };
}

export function leagueLeaderBoardFetchDataSuccess(data) {
    return {
        type: LEAGUE_LEADERBOARD_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function leagueLeaderboardHasError(bool) {
    return {
        type: LEAGUE_LEADERBOARD_HAS_ERROR,
        payload: bool
    };
}

export function isLeagueLeaderBoardPublicLoading(bool) {
    return {
        type: IS_LEAGUE_LEADERBOARD_PUBLIC_LOADING,
        payload: bool
    };
}

export function leagueLeaderBoardPublicFetchDataSuccess(data) {
    return {
        type: LEAGUE_LEADERBOARD_PUBLIC_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function leagueLeaderboardPublicHasError(bool) {
    return {
        type: LEAGUE_LEADERBOARD_PUBLIC_HAS_ERROR,
        payload: bool
    };
}

export function isLeagueLeaderBoardRankLoading(bool) {
    return {
        type: IS_LEAGUE_LEADERBOARD_RANK__LOADING,
        payload: bool
    };
}

export function leagueLeaderBoardRankFetchDataSuccess(data) {
    return {
        type: LEAGUE_LEADERBOARD_RANK__FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function leagueLeaderboardRankHasError(bool) {
    return {
        type: LEAGUE_LEADERBOARD_RANK__HAS_ERROR,
        payload: bool
    };
}

export function isGetLeagueMembersLoading(bool) {
    return {
        type: IS_GET_LEAGUE_MEMBERS_LOADING,
        payload: bool
    };
}

export function leagueMembersFetchDataSuccess(data) {
    return {
        type: LEAGUE_MEMBERS_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function leagueMembersHasError(bool) {
    return {
        type: LEAGUE_MEMBERS_HAS_ERROR,
        payload: bool
    };
}

export function isCreateLeagueLoading(bool) {
    return {
        type: IS_CREATE_LEAGUE_LOADING,
        payload: bool
    };
}

export function createLeagueFetchDataSuccess(data) {
    return {
        type: CREATE_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function createLeagueHasError(bool) {
    return {
        type: CREATE_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isJoinLeagueLoading(bool) {
    return {
        type: IS_JOIN_LEAGUE_LOADING,
        payload: bool
    };
}

export function joinLeagueFetchDataSuccess(data) {
    return {
        type: JOIN_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function joinLeagueHasError(bool) {
    return {
        type: JOIN_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isLeaveLeagueLoading(bool) {
    return {
        type: IS_LEAVE_LEAGUE_LOADING,
        payload: bool
    };
}

export function leaveLeagueFetchDataSuccess(data) {
    return {
        type: LEAVE_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function leaveLeagueHasError(bool) {
    return {
        type: LEAVE_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isRelaunchLeagueLoading(bool) {
    return {
        type: IS_RELAUNCH_LEAGUE_LOADING,
        payload: bool
    };
}

export function relaunchLeagueFetchDataSuccess(data) {
    return {
        type: RELAUNCH_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function relaunchLeagueHasError(bool) {
    return {
        type: RELAUNCH_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isReJoinLeagueLoading(bool) {
    return {
        type: IS_RE_JOIN_LEAGUE_LOADING,
        payload: bool
    };
}

export function reJoinLeagueFetchDataSuccess(data) {
    return {
        type: RE_JOIN_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function reJoinLeagueHasError(bool) {
    return {
        type: RE_JOIN_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isDeleteLeagueLoading(bool) {
    return {
        type: IS_DELETE_LEAGUE_LOADING,
        payload: bool
    };
}

export function deleteLeagueFetchDataSuccess(data) {
    return {
        type: DELETE_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function deleteLeagueHasError(bool) {
    return {
        type: DELETE_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isPreviousSeasonDeleteLeagueLoading(bool) {
    return {
        type: IS_PREVIOUS_SEASON_DELETE_LEAGUE_LOADING,
        payload: bool
    };
}

export function previousSeasonDeleteLeagueFetchDataSuccess(data) {
    return {
        type: PREVIOUS_SEASON_DELETE_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function previousSeasonDeleteLeagueHasError(bool) {
    return {
        type: PREVIOUS_SEASON_DELETE_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isPreviousSeasonMemberDeleteLoading(bool) {
    return {
        type: IS_PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_LOADING,
        payload: bool
    };
}

export function previousSeasonMemberDeleteFetchDataSuccess(data) {
    return {
        type: PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function previousSeasonMemberDeleteHasError(bool) {
    return {
        type: PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isSuspendLeagueLoading(bool) {
    return {
        type: IS_SUSPEND_LEAGUE_LOADING,
        payload: bool
    };
}

export function suspendLeagueFetchDataSuccess(data) {
    return {
        type: SUSPEND_LEAGUE_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function suspendLeagueHasError(bool) {
    return {
        type: SUSPEND_LEAGUE_HAS_ERROR,
        payload: bool
    };
}

export function isRemoveSuspensionLoading(bool) {
    return {
        type: IS_REMOVE_SUSPENSION_LOADING,
        payload: bool
    };
}

export function removeSuspensionFetchDataSuccess(data) {
    return {
        type: REMOVE_SUSPENSION_FETCH_DATA_SUCCESS,
        payload: data
    };
}

export function removeSuspensionHasError(bool) {
    return {
        type: REMOVE_SUSPENSION_HAS_ERROR,
        payload: bool
    };
}

export function updateFavTeamLoading(bool) {
    return {
        type: UPDATE_FAV_TEAM_LOADING,
        payload: bool
    };
}

export function updateFavTeamSuccess(data, dispatch) {
    if (data.Meta['RetVal'] === 1) {
        if (clubName == "_skipped") {
            common.customTracking('Public Club League - Skip');
        }
        else {
            common.customTracking('Public Club League - Join - ' + clubName, '/uclfantasy/leagues/');
        }
        clubName = "";
        const GUID = common.getGUID();
        const CountryId = common.getDataFromCookie('CountryId');
        const FavTeamId = common.getDataFromCookie('FavSoccerTeamId');
        dispatch(getPublicLeaguesData(GUID, CountryId, FavTeamId, config.CURRENT_LANGUAGE))
    }
    return {
        type: UPDATE_FAV_TEAM_SUCCESS,
        payload: data
    };
}

export function updateFavTeamError(bool) {
    return {
        type: UPDATE_FAV_TEAM_ERROR,
        payload: bool
    };
}

export function getLeaguesData(GUID, pageNo) {
    let params = {
        vPageNo: pageNo,
        vTopNo: config.leaguesPageSize,
    };
    const getLeaguesURL = getLeagues.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(getLeaguesURL, dispatch, isGetLeagueLoading, leaguesFetchDataSuccess, leaguesHasError, params);
}

export function getPublicLeaguesData(GUID, CountryId, FavTeamId, LangCode) {
    let params = {
        OptType: 1,
        CountryId,
        FavTeamId,
        LangCode,
    };
    const getPublicLeaguesURL = getPublicLeagues.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(getPublicLeaguesURL, dispatch, isPublicLeagueLoading, publicLeaguesFetchDataSuccess, publicLeaguesHasError, params);
}

export function getLeagueLeaderBoardData(opType, vPageNo, vPageChunk, vTopNo, leagueid, vPhaseId, gamedayId, vPageOneChunk) {
    let params = {
        OptType: opType,
        vPageNo, vPageChunk, vTopNo, leagueid, vPhaseId, gamedayId, vPageOneChunk
    };
    const getLeagueLeaderBoardURL = getLeagueLeaderBoard.replace('{LEAGUE_ID}', leagueid);
    return (dispatch) => common.makeAPICall(getLeagueLeaderBoardURL, dispatch, isLeagueLeaderBoardLoading, leagueLeaderBoardFetchDataSuccess, leagueLeaderboardHasError, params);
}

export function getPublicLeagueLeaderBoardData(opType, vPageNo, vPageChunk, vTopNo, TypeID, countryID, clubID, phaseId, gamedayId) {
    let params = {
        optType: opType,
        vPageNo, vPageChunk, vTopNo, phaseId, gamedayId
    };
    const GUID = common.getGUID();
    // const getLeagueLeaderBoardURL = publicLeaderBoard[TypeID].replace('{GUID}', GUID).replace('{TEAM_ID}', clubID).replace('{COUNTRY_ID}', countryID);
    let getLeagueLeaderBoardURL = publicLeaderBoard[TypeID]
    let appendURL = ""
    switch (Number(TypeID)) {
        case config.publicLeaderBoardTypes.overall:
            getLeagueLeaderBoardURL = getLeagueLeaderBoardURL.replace('{type}', 'global')
            break;
        case config.publicLeaderBoardTypes.country:
            getLeagueLeaderBoardURL = getLeagueLeaderBoardURL.replace('{type}', 'country_' + countryID)
            break;
        case config.publicLeaderBoardTypes.club:
            getLeagueLeaderBoardURL = getLeagueLeaderBoardURL.replace('{type}', 'favteam_' + clubID)
            break;
        case config.publicLeaderBoardTypes.knockout:
            getLeagueLeaderBoardURL = getLeagueLeaderBoardURL.replace('{type}', 'knockout')
            break;
    }
    if (opType == 1) {
        appendURL = "overall/" + config.TourId + "-" + vPageNo
    } else if (opType == 2) {
        appendURL = "gameday-" + gamedayId + "/" + config.TourId + "-" + vPageNo
    } else if (opType == 3) {
        appendURL = "phase-" + phaseId + "/" + config.TourId + "-" + vPageNo
    }
    getLeagueLeaderBoardURL += appendURL + ".json"

    return (dispatch) => common.makeAPICall(getLeagueLeaderBoardURL, dispatch, isLeagueLeaderBoardPublicLoading, leagueLeaderBoardPublicFetchDataSuccess, leagueLeaderboardPublicHasError, params);
}

export function getPublicLeagueLeaderBoardRankData(opType, vPageNo, vPageChunk, vTopNo, TypeID, countryID, clubID, phaseId, gamedayId) {
    let params = {
        OptType: opType,
        vPageNo, vPageChunk, vTopNo, phaseId, gamedayId
    };
    const GUID = common.getGUID();
    const getLeagueLeaderBoardRankURL = publicLeaderBoardRank[TypeID].replace('{GUID}', GUID).replace('{TEAM_ID}', clubID).replace('{COUNTRY_ID}', countryID);
    return (dispatch) => common.makeAPICall(getLeagueLeaderBoardRankURL, dispatch, isLeagueLeaderBoardRankLoading, leagueLeaderBoardRankFetchDataSuccess, leagueLeaderboardRankHasError, params);
}

export function getLeagueMembersData(leagueID, pageNo, chunkSize) {
    let params = {
        vPageNo: pageNo,
        vTopNo: chunkSize,
        leagueid: leagueID,
    };
    const getLeagueMembersURL = getMembers.replace('{LEAGUE_ID}', leagueID);
    return (dispatch) => common.makeAPICall(getLeagueMembersURL, dispatch, isGetLeagueMembersLoading, leagueMembersFetchDataSuccess, leagueMembersHasError, params);
}

export function createLeague(GUID, leagueName) {
    let params = {
        "OptType": 1,
        "GamedayId": 0,
        "LeagueName": leagueName,
        "LeagueCode": "",
        "LeagueId": 0
    };
    const postCreateLeagueURL = postCreateLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postCreateLeagueURL, dispatch, isCreateLeagueLoading, createLeagueFetchDataSuccess, createLeagueHasError, params, 'POST');
}

export function joinLeague(GUID, leagueCode) {
    let params = {
        "OptType": 0,
        "GamedayId": 0,
        "LeagueCode": leagueCode,
        "LeagueId": 0
    };
    const postJoinLeagueURL = postJoinLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postJoinLeagueURL, dispatch, isJoinLeagueLoading, joinLeagueFetchDataSuccess, joinLeagueHasError, params, 'POST');
}

export function leaveLeague(GUID, leagueID, LeagueCode) {
    let params = {
        "OptType": 1,
        "GamedayId": 0,
        "LeagueName": "string",
        "LeagueCode": LeagueCode,
        "LeagueId": leagueID
    };
    const postLeaveLeagueURL = postLeaveLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postLeaveLeagueURL, dispatch, isLeaveLeagueLoading, leaveLeagueFetchDataSuccess, leaveLeagueHasError, params, 'POST');
}

export function relaunchLeague(GUID, leagueID, leagueCode) {
    let params = {
        "OptType": 1,
        "GamedayId": 0,
        "LeagueName": "",
        "LeagueCode": leagueCode,
        "LeagueId": leagueID
    };
    const postRelaunchLeagueURL = postRelaunchLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postRelaunchLeagueURL, dispatch, isRelaunchLeagueLoading, relaunchLeagueFetchDataSuccess, relaunchLeagueHasError, params, 'POST');
}

export function reJoinLeague(GUID, leagueID, leagueCode) {
    let params = {
        "OptType": 1,
        "GamedayId": 0,
        "LeagueName": "",
        "LeagueCode": leagueCode,
        "LeagueId": leagueID
    };
    const postReJoinLeagueURL = postReJoinLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postReJoinLeagueURL, dispatch, isReJoinLeagueLoading, reJoinLeagueFetchDataSuccess, reJoinLeagueHasError, params, 'POST');
}

export function deleteLeague(GUID, leagueID, leagueCode) {
    let params = {
        "OptType": 1,
        "GamedayId": 0,
        "LeagueName": "",
        "LeagueCode": leagueCode,
        "LeagueId": leagueID
    };
    const postDeleteLeagueURL = postDeleteLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postDeleteLeagueURL, dispatch, isDeleteLeagueLoading, deleteLeagueFetchDataSuccess, deleteLeagueHasError, params, 'POST');
}

export function previousSeasonDeleteLeague(GUID, leagueID, leagueCode) {
    let params = {
        "OptType": 1,
        "GamedayId": 0,
        "LeagueName": "",
        "LeagueCode": leagueCode,
        "LeagueId": leagueID
    };
    const postPreviousSeasonDeleteLeagueURL = postPreviousSeasonDeleteLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postPreviousSeasonDeleteLeagueURL, dispatch, isPreviousSeasonDeleteLeagueLoading, previousSeasonDeleteLeagueFetchDataSuccess, previousSeasonDeleteLeagueHasError, params, 'POST');
}

export function previousSeasonMemberDeleteLeague(GUID, leagueID, leagueCode) {
    let params = {
        "OptType": 1,
        "GamedayId": 0,
        "LeagueName": "",
        "LeagueCode": leagueCode,
        "LeagueId": leagueID
    };
    const postPreviousSeasonMemberDeleteLeagueURL = postPreviousSeasonMemberDeleteLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postPreviousSeasonMemberDeleteLeagueURL, dispatch, isPreviousSeasonMemberDeleteLoading, previousSeasonMemberDeleteFetchDataSuccess, previousSeasonMemberDeleteHasError, params, 'POST');
}

export function suspendLeague(GUID, MemberId, MemberTeamId, LeagueId) {
    let params = {
        "OptType": 1,
        "MemberId": MemberId,
        "MemberTeamId": MemberTeamId,
        "LeagueId": LeagueId
    };
    const postSuspendLeagueURL = postSuspendLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postSuspendLeagueURL, dispatch, isSuspendLeagueLoading, suspendLeagueFetchDataSuccess, suspendLeagueHasError, params, 'POST');
}

export function removeLeagueSuspension(GUID, MemberId, MemberTeamId, LeagueId) {
    let params = {
        "OptType": 1,
        "MemberId": MemberId,
        "MemberTeamId": MemberTeamId,
        "LeagueId": LeagueId
    };
    const postRemoveSuspensionLeagueURL = postRemoveSuspensionLeague.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(postRemoveSuspensionLeagueURL, dispatch, isRemoveSuspensionLoading, removeSuspensionFetchDataSuccess, removeSuspensionHasError, params, 'POST');
}

export function updateLeagueNamePost(GUID, leagueName, leagueID) {
    let params = {
        "OptType": 1,
        "LeagueName": leagueName,
        "LeagueId": leagueID
    };
    const updateLeagueNameURL = updateLeagueName.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(updateLeagueNameURL, dispatch, isUpdateLeagueNameLeagueLoading, leagueNameUpdateFetchDataSuccess, updateLeaguesHasError, params, 'POST');
}

export function getOtherUsersTeam(GUID, GDID, UserId, UserTeamId) {
    let params = {
        optType: 1,
        gamedayId: GDID || 0,
        phaseId: 0,
        userId: UserId,
        teamId: UserTeamId,
        language: config.CURRENT_LANGUAGE,
    };
    const viewOtherUsersTeamURL = viewOtherUsersTeam.replace('{GUID}', GUID);
    return (dispatch) => common.makeAPICall(viewOtherUsersTeamURL, dispatch, isGetOthersTeamLoading, GetOthersTeamFetchDataSuccess, GetOthersTeamHasError, params);
}

export function updateFavouriteTeam(optType, club) {
    clubName = (club && optType == 1 ? club.OffName : "_skipped")
    let params = {
        "OptType": optType,
        "FavTeamId": (club ? club.Id : 0)
    }
    return (dispatch) => common.makeAPICall(postFavTeam, dispatch, updateFavTeamLoading, updateFavTeamSuccess, updateFavTeamError, params, 'POST');
}


// WEBPACK FOOTER //
// ./src/actions/LeagueActions.js